/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leaderboard_No_Records_FoundInputs */

const fr_leaderboard_no_records_found = /** @type {(inputs: Leaderboard_No_Records_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun record personnel trouvé pour cette combinaison exercice et type.`)
};

/**

* @param {Leaderboard_No_Records_FoundInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const leaderboard_no_records_found = /** @type {((inputs?: Leaderboard_No_Records_FoundInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leaderboard_No_Records_FoundInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_leaderboard_no_records_found(inputs)
});